import { Box, styled } from '@mui/material';

export const ViewerBox = styled(Box)(({ theme }) => ({
  '& .ProseMirror': {
    fontFamily: 'Montserrat, sans-serif',

    ':focus-visible': { outline: 'none' },

    p: { margin: '0 0 8px' },

    a: {
      color: theme.palette.secondary.main,
    },
  },
}));
